import React, { useEffect, useState, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../mockData';

const OperatorSection = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const operatorContent = content[language].operator;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section 
      id="operator" 
      ref={sectionRef}
      className="section section-ivory"
    >
      <div className="container-narrow">
        {/* Header */}
        <div className={`text-center mb-48 fade-in-up ${isVisible ? 'visible' : ''}`}>
          <h2 className="mb-32">{operatorContent.title}</h2>
          <p style={{ fontSize: '1.0625rem' }}>{operatorContent.approach}</p>
        </div>

        {/* Structure */}
        <div style={{ display: 'grid', gap: '40px', marginTop: '64px' }}>
          {operatorContent.structure.map((item, index) => (
            <div
              key={item.title}
              className={`fade-in-up ${isVisible ? 'visible' : ''}`}
              style={{
                padding: '32px 40px',
                background: '#ffffff',
                border: '1px solid rgba(0,0,0,0.1)',
                transitionDelay: `${0.2 + index * 0.15}s`
              }}
            >
              <h4 className="mb-16" style={{ fontSize: '1.125rem', color: 'var(--olive)' }}>
                {item.title}
              </h4>
              <p style={{ fontSize: '0.9375rem', margin: 0 }}>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OperatorSection;
